import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectTypeOrg {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectTypeOrg = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectTypeOrg) => {
  //const itemList = useStoreState((state) => state.common.districtList);
  const itemList = [
    {
      id: "Education",
      value: 'Education'
    },
    {
      id: "Business",
      value: 'Business'
    },
    {
      id: "NGO",
      value: 'NGO'
    },
  ];
  // const itemListFetch = useStoreActions((state) => state.common.itemListFetch);
   const setselectedCat = useStoreActions((state) => state.order.setselectedCat);
  // if (itemList === null) {
  //   itemListFetch();
  // }

  const onSelect = (id) => {
    setselectedCat(id);
    if (itemList) {
      const val = itemList.find((item) => item.id === id);
      onChange(val);
    }
  };




  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected?.id}
      style={style}
      placeholder="Select Type"
      filterOption={(input, option) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.id} value={type.id}>
            {type.value}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Type</Option>
      )}
    </Select>
  );
};
